import Component from '@glimmer/component';
import { service } from '@ember/service';
import { restartableTask } from 'ember-concurrency';
import { t } from 'ember-intl';
import type { Store } from '@warp-drive/core';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import Table from 'tio-ui/components/table';
import type Owner from '@ember/owner';
import type { FamilyExtension as FamilyModel } from 'tio-data/data/resources/family.ext';
import { tracked } from '@glimmer/tracking';
import { query } from '@warp-drive/utilities/json-api';

interface FamilyInvitesTableSignature {
  Args: {
    limit: number;
    employees: EmployeeModel[];
  };
}

export default class FamilyInvitesTableComponent extends Component<FamilyInvitesTableSignature> {
  @service declare store: Store;

  constructor(owner: Owner, args: FamilyInvitesTableSignature['Args']) {
    super(owner, args);
    this.loadRecords.perform();
  }

  @tracked familyInvites?: FamilyModel[];

  get isLoading() {
    return this.loadRecords.isRunning;
  }

  get employees() {
    return this.args.employees?.slice() || [];
  }

  loadRecords = restartableTask(async () => {
    const { content } = (await this.store.request(
      query<FamilyModel>('family', {
        'filter[employee]': this.employees[0]?.id || '',
        'page[limit]': this.args.limit,
        'page[offset]': 0,
        include: 'family-invites,user',
      })
    )) as { content: { data: FamilyModel[] } };
    this.familyInvites = content.data;
  });

  <template>
    <Table @isLoading={{this.isLoading}}>
      <:thead as |options|>
        <options.tr>
          <options.th>{{t "common.profile.family_invites.family_id"}}</options.th>
          <options.th>{{t "common.profile.family_invites.name"}}</options.th>
          <options.th>{{t "common.profile.family_invites.user_id"}}</options.th>
          <options.th>{{t "common.profile.family_invites.relationship"}}</options.th>
        </options.tr>
      </:thead>
      <:tbody as |options|>
        {{#each this.familyInvites as |invite|}}
          <options.tr>
            <options.td>{{invite.id}}</options.td>
            {{!-- <options.td>{{invite.fullName}}</options.td>
            <options.td>{{invite.user.id}}</options.td>
            <options.td>{{invite.familyRelationshipTypeId}}</options.td> --}}
          </options.tr>
        {{/each}}
      </:tbody>
    </Table>
  </template>
}
